import script from "./ImagePreview.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagePreview.vue?vue&type=script&setup=true&lang=js"

import "./ImagePreview.vue?vue&type=style&index=0&id=4d6ad81e&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6ad81e"]])

export default __exports__